import { Search } from 'lucide-react'
import { Link } from 'react-router-dom'
export function NotFoundPage() { return <div className="page empty-state"><Search/><h1>페이지를 찾지 못했어요</h1><p>주소가 바뀌었거나 잘못 입력되었을 수 있어요.</p><Link className="primary-button" to="/">홈으로 돌아가기</Link><Link className="secondary-button" to="/products">전체 제품 보기</Link></div> }
